'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as HublValidatorActions from 'DesignData/actions/HublValidator';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import CodePanes from 'DesignEditorsUI/components/customWidgetEditor/codePanes/CodePanes';

function makeMapStateToProps() {
  const getIsEmailOrAnyType = customWidgetBuffersSelectors.makeGetIsEmailOrAnyType();
  const getUpgradeNotPublished = customWidgetBuffersSelectors.makeGetUpgradeNotPublished();
  return (state, __props) => {
    const props = Object.assign({}, __props, {
      assetId: __props.customWidgetId
    });
    return {
      customWidgetId: props.customWidgetId,
      paneOptions: customWidgetEditorOptionsSelectors.getPaneOptions(state, props),
      upgradeNotPublished: getUpgradeNotPublished(state, props),
      isEmailOrAnyType: getIsEmailOrAnyType(state, props)
    };
  };
}

const mapDispatchToProps = {
  updatePaneOptions: CustomWidgetEditorOptionsActions.updatePaneOptions,
  updateCustomWidget: CustomWidgetBufferActions.update,
  validateTemplate: HublValidatorActions.validateTemplate
};

class CodePanesContainer extends PureComponent {
  constructor(...args) {
    super(...args);

    this.updateSource = source => {
      const {
        updateCustomWidget,
        customWidgetId
      } = this.props;
      updateCustomWidget(customWidgetId, source);
    };

    this.onHublValidation = (sessionId, annotations, apiResponse) => {
      this.props.validateTemplate(this.props.customWidgetId, sessionId, apiResponse, null);
    };

    this.onHublValidationFail = (sessionId, apiResponse) => {
      this.props.validateTemplate(this.props.customWidgetId, sessionId, null, apiResponse);
    };
  }

  render() {
    const {
      customWidgetId,
      revisionId,
      paneOptions,
      updatePaneOptions,
      isEmailOrAnyType,
      onCodePanesRender
    } = this.props;
    return /*#__PURE__*/_jsx(CodePanes, {
      customWidgetId: customWidgetId,
      revisionId: revisionId,
      paneOptions: paneOptions,
      updateSource: this.updateSource,
      updatePaneOptions: updatePaneOptions,
      onHublValidation: this.onHublValidation,
      onHublValidationFail: this.onHublValidationFail,
      isEmailOrAnyType: isEmailOrAnyType,
      onCodePanesRender: onCodePanesRender
    });
  }

}

CodePanesContainer.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  revisionId: PropTypes.number,
  paneOptions: PropTypes.object.isRequired,
  updateCustomWidget: PropTypes.func.isRequired,
  updatePaneOptions: PropTypes.func.isRequired,
  validateTemplate: PropTypes.func.isRequired,
  isEmailOrAnyType: PropTypes.bool.isRequired,
  onCodePanesRender: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(CodePanesContainer);